module.exports = __webpack_public_path__ + "media/images/plumbing-repair-service-1dd6055c507579cbebc29b23df70d277.jpg";